<template>
  <div class="landscape-tip-wrapper" @touchstart.prevent>
    <div class="inner">
      <div class="tip-img"></div>
      <p class="tip">请将手机竖过来填写</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LandScapeTip'
};
</script>
<style scoped lang="scss">
.landscape-tip-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: #606060;
  /* background: rgba(0, 0, 0, .6); */
  z-index: 10001;
  display: flex;
  .inner {
    margin: auto;
  }
  .tip-img {
    width: 153px;
    height: 153px;
    background: url(~@/assets/images/landscape-tip.gif) no-repeat;
    background-size: cover;
    margin: auto;
  }
  .tip {
    font-size: 16px;
    line-height: 22px;
    color: #FFFFFF;
  }
}
</style>
